import axios from 'axios';

import { getBaseUrl, getSiteOwnership, log } from 'common/utils';
import { ENV, VALID } from 'common/const';

import mock from './verifyOtp.mock';

const baseUrl = getBaseUrl(2);
const ownership = getSiteOwnership();

/**
 * Verifies a one-time passcode and authenticates the customer
 * @param {string} user.email
 * @param {string} user.otp
 * @returns Object with customerId and jwtToken
 */
const verifyOtp = async ({ email, otp }) => {
  await VALID.checkAll(['Email', email, VALID.EMAIL], ['Otp', otp, VALID.OTP]);

  try {
    const { data: auth = {} } = ENV.IS_MOCK
      ? mock()
      : await axios.post(`${baseUrl}customer/verify_otp`, {
          email: `${email}`,
          otp: `${otp}`,
          ownership: `${ownership}`,
        });

    return {
      customerId: auth.customerId,
      jwtToken: auth.jwtToken,
    };
  } catch (error) {
    log('verifyOtp', {
      api: error.response?.status !== 400,
      data: { email },
      error,
      throw: true,
      type: 'request',
    });
  }
};

export default verifyOtp;
